<template>
    <div>
        <div class="flex justify-between">
            <h6 class="bold mt-3">Despacho de Cobranza Asignado:</h6>
            <vs-button v-if="!debtCollectorProjectAssignment" color="primary" type="flat" icon-pack="feather"
                icon="icon-edit" @click="editDebtCollectorProjectAssignment" />
            <vs-button v-else color="danger" type="flat" icon-pack="feather" icon="icon-trash"
                @click="confirmUnassignDebtCollector" />
        </div>
        <vs-list>
            <template v-if="debtCollectorProjectAssignment">
                <vs-list-item :title="debtCollectorProjectAssignment.debt_collector.name"></vs-list-item>
                <vs-list-item title="Fecha inicio">{{ debtCollectorProjectAssignment.start_date }}</vs-list-item>
                <vs-list-item title="Fecha fin">{{ debtCollectorProjectAssignment.end_date }}</vs-list-item>
            </template>
            <template v-else>
                <vs-list-item subtitle="Sin despacho adjudicado actualmente"></vs-list-item>
            </template>
        </vs-list>

        <!-- MODAL ADJUDICAR -->
        <vs-popup class="mid-popup header-primary" title="Adjudicar" :active.sync="popupAssignActive">
            <div class="vx-row mt-base mb-base">
                <div class="vx-col w-full">
                    <vs-select placeholder="Seleccione" label="Despacho" class="w-full" v-model="debtCollectorSelected">
                        <vs-select-item :key="index" :value="item.id" :text="item.name"
                            v-for="(item, index) in collections.debtCollectorsOptions" />
                    </vs-select>
                    <!-- <vs-select placeholder="Seleccione" label="Mes de asignación" class="w-full mt-5"
                        v-model="monthSelected">
                        <vs-select-item :key="index" :value="item.value" :text="item.text"
                            v-for="(item, index) in monthOptions" />
                    </vs-select> -->
                    <vs-button :disabled="!debtCollectorSelected || !monthSelected" @click="confirmAssignDebtCollector"
                        color="success" class="mt-6 mb-6 mr-1">Continuar</vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>

export default {
    name: "DebtCollectorProjectAssignment",
    props: {
        projectId: {
            required: true
        },
        currentDebtCollectorProjectAssignment: {
            default: null
        },
    },
    async mounted() {
    },
    data() {
        return {
            debtCollectorProjectAssignment: this.currentDebtCollectorProjectAssignment,
            collections: {
                ccPreventionCodeOptions: [],
                debtCollectorsOptions: [],
            },
            popupAssignActive: false,
            debtCollectorSelected: null,
            monthSelected: 'current',
            monthOptions: [
                { text: 'Actual', value: 'current' },
                { text: 'Siguiente', value: 'next' }
            ],
        }
    },
    watch: {
    },
    computed: {
    },
    methods: {
        async getCollections() {
            try {
                this.collections.debtCollectorsOptions = [];
                let collectionsObjects = ['debtCollectors'];
                let params = "with[]=" + collectionsObjects.join("&with[]=");
                let res = await axios.get(`/api/v1/forms/getFormCollections?${params}`);
                let colls = res.data;
                colls.debtCollectors.forEach((opt) => {
                    this.collections.debtCollectorsOptions.push({
                        id: opt.id,
                        name: opt.name,
                    }); //conversion a sintaxis de vx-select
                });
            } catch (e) {
                this.warn(e);
                this.failed = true;
            }
        },
        async editDebtCollectorProjectAssignment() {
            await this.getCollections();
            this.popupAssignActive = true;
        },
        async confirmAssignDebtCollector() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Aviso`,
                text: "¿Estas seguro de querer adjudicar el despacho al proyecto?",
                acceptText: "Confirmar",
                cancelText: "Cancelar",
                accept: this.assignDebtCollector
            })
        },
        confirmUnassignDebtCollector() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Aviso`,
                text: "¿Estas seguro de querer quitar el despacho al proyecto?",
                acceptText: "Confirmar",
                cancelText: "Cancelar",
                accept: this.unassignDebtCollector
            })
        },
        async assignDebtCollector() {
            this.showLoading(true);
            let payload = {
                project_id: this.projectId,
                debt_collector_id: this.debtCollectorSelected,
                // option_month: this.monthSelected,
            };
            await axios.post('/api/cobranza/assign-debt-collector-project', payload).then(async response => {
                this.popupAssignActive = false;
                this.showLoading(false);
                this.successNotif("Aviso", 'Despacho asignado exitosamente', 4000);
                await this.sleep(1000) // espera 2 segundos
                this.$emit('updated', 1)
            }).catch(error => {
                this.showLoading(false);
                if (error.response.data.message != undefined) {
                    this.errorNotif("Aviso", error.response.data.message, 4000);
                } else {
                    this.errorNotif("Aviso", 'Ha ocurrido un error intente mas tarde.', 4000);
                }
            });
        },
        async unassignDebtCollector() {
            this.showLoading(true);
            let payload = {
                project_id: this.projectId,
                debt_collector_project_assignment_id: this.debtCollectorProjectAssignment.id
            };
            await axios.post('/api/cobranza/unassign-debt-collector-project', payload).then(response => {
                this.showLoading(false);
                this.successNotif("Aviso", 'Despacho quitado exitosamente', 4000);
                this.debtCollectorProjectAssignment = null;
                this.debtCollectorSelected = null;
            }).catch(error => {
                this.showLoading(false);
                if (error.response.data.message != undefined) {
                    this.errorNotif("Aviso", error.response.data.message, 4000);
                } else {
                    this.errorNotif("Aviso", 'Ha ocurrido un error intente mas tarde.', 4000);
                }
            });
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms))
        },
    }
}
</script>